import { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useLecturerCode = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lecturerCodeList, setLecturerCodeList] = useState<UserCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.lecturer.codelist],
    () => fetcher.lecturer.getLecturerCodeList(),
    {
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setLecturerCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, lecturerCodeList };
};

export default useLecturerCode;
